<template>
  <div v-if="hasSentError" class="w-max p-5">
    Sample error was sent to Sentry.
  </div>
  <WebccButton v-else @click="throwError">Throw Sample Error</WebccButton>
</template>

<script lang="ts" setup>
import { WebccButton } from '#components'
import * as Sentry from '@sentry/nuxt'

const hasSentError = ref(false)

const throwError = () => {
  Sentry.startSpan(
    {
      name: 'Example Frontend Span',
      op: 'test',
    },
    () => {
      hasSentError.value = true
      throw new Error('Sentry Example Error')
    },
  )
}
</script>
